var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isReady),expression:"isReady"}]},[_c('Header',{attrs:{"isLink":false}}),_vm._v(" "),_c('div',{staticClass:"main"},[_c('TopCap',{attrs:{"page":"interview"}}),_vm._v(" "),_c('ul',_vm._l((_vm.list),function(l,i){return _c('li',[_c('Item',{attrs:{"l":l}})],1)}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }